// extracted by mini-css-extract-plugin
module.exports = {"mdBreakPoint":"992","promos":"_36tfVHCgQwtWq6BP","promos__item":"uXSSPGZAFn3w0aUJ"};